<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <template>
        <div>
          <div class="summary">
            <div class="board">
              <h1>
                {{ this.$t('reports.summaryBoard.reportTitle') }}
              </h1>
              <div class="container">
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.invitesLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ amountInvites }}</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.answersLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ amountAnswers }}</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>
                      {{ this.$t('reports.summaryBoard.conversionLabel') }}
                    </h2>
                  </header>
                  <div class="description">
                    <span
                      >{{
                        ((amountAnswers / amountInvites) * 100).toFixed(0)
                      }}%</span
                    >
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>
                      % {{ this.$t('reports.summaryBoard.receivedEmails') }}
                    </h2>
                  </header>
                  <div class="description">
                    <span>{{ details.email ? details.email.percentil : '' }}%</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>
                      % {{ this.$t('reports.summaryBoard.receivedPhones') }}
                    </h2>
                  </header>
                  <div class="description">
                    <span>{{ details.sms ? details.sms.percentil : '' }}%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="board">
              <h1>{{ this.$t('reports.summaryBoard.channelQtLabel') }}</h1>
              <div class="container">
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.emailLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ answersByEmail.total }}</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.smsLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ answersByPhone.total }}</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.manualLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ answersByManual.total }}</span>
                  </div>
                </div>
                <div class="item">
                  <header>
                    <h2>{{ this.$t('reports.summaryBoard.othersLabel') }}</h2>
                  </header>
                  <div class="description">
                    <span>{{ answersByLinkWppWppWidgetQrCode.total }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="row mt-4">
        <div class="col-4" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <div class="col-12" style="display: flex;">
              <div style="min-width: 70%;">
                <nps-bar />
              </div>
              <div style="min-width: 30%; text-align: center;">
                <div class="board-percentil" style="padding-top: 60px;">
                  <span class="board-percentil-label">
                    {{ this.$t('reports.summaryBoard.promoterLabel') }}
                  </span>
                  <br />
                  <strong class="board-percentil-percent">
                    {{
                      this.amountAnswers
                        ? (
                            (100 * this.percentilNps.promoters) /
                            this.amountAnswers
                          ).toFixed(0)
                        : 0
                    }}%
                  </strong>
                  /
                  <span class="board-percentil-value">
                    {{ this.percentilNps.promoters }}
                  </span>
                </div>
                <div class="board-percentil">
                  <span class="board-percentil-label">
                    {{ this.$t('reports.summaryBoard.neutralLabel') }}
                  </span>
                  <br />
                  <strong class="board-percentil-percent">
                    {{
                      this.amountAnswers
                        ? (
                            (100 * this.percentilNps.passive) /
                            this.amountAnswers
                          ).toFixed(0)
                        : 0
                    }}%
                  </strong>
                  /
                  <span class="board-percentil-value">
                    {{ this.percentilNps.passive }}
                  </span>
                </div>
                <div class="board-percentil">
                  <span class="board-percentil-label">
                    {{ this.$t('reports.summaryBoard.detractorLabel') }}
                  </span>
                  <br />
                  <strong class="board-percentil-percent">
                    {{
                      this.amountAnswers
                        ? (
                            (100 * this.percentilNps.detractors) /
                            this.amountAnswers
                          ).toFixed(0)
                        : 0
                    }}%
                  </strong>
                  /
                  <span class="board-percentil-value">
                    {{ this.percentilNps.detractors }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="myIh1 != 0" class="col-12 text-center">
              {{ this.$t('reports.summaryBoard.positionMsg1') }}
              {{ this.branchRanking }}
              <span>&#186;</span>
              {{ this.$t('reports.summaryBoard.positionMsg2') }}
            </div>
          </div>
        </div>
        <div class="col-8" style="padding: 0px 10px;">
          <div class="col-12 board-border" style="padding: 0px 10px;">
            <basic-column :reportType="reportType" :accumulated="false" />
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <h1>
              <strong>
                {{ this.$t('reports.summaryBoard.top5detractors') }}
              </strong>
            </h1>
            <table class="table" v-if="catDetractors.qtd > 0">
              <caption>
                <div class="pull-right mr-3">
                  {{
                    this.percentilNps.detractors
                      ? (
                          (100 * this.catDetractors.qtd) /
                          this.percentilNps.detractors
                        ).toFixed(0)
                      : 0
                  }}{{ this.$t('reports.summaryBoard.categorizedLabel') }}
                </div>
              </caption>
              <tbody>
                <tr
                  v-for="(i, item, index) in catDetractors.items"
                  :key="index"
                >
                  <td>{{ getCategoryName(item) }}</td>
                  <td style="width: 40%;">
                    <div class="mt-2">
                      <b-progress
                        variant="danger"
                        :value="Math.round((i / catDetractors.qtd) * 100)"
                        :max="100"
                      ></b-progress>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      {{ Math.round((i / catDetractors.qtd) * 100) }}%
                    </div>
                  </td>
                  <td>
                    <div class="text-center">{{ i }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 mt-4" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <h1>
              <strong>
                {{ this.$t('reports.summaryBoard.top5promoters') }}
              </strong>
            </h1>
            <table class="table" v-if="catPromoters.qtd > 0">
              <caption>
                <div class="pull-right mr-3">
                  {{
                    this.percentilNps.promoters
                      ? (
                          (100 * this.catPromoters.qtd) /
                          this.percentilNps.promoters
                        ).toFixed(0)
                      : 0
                  }}{{ this.$t('reports.summaryBoard.categorizedLabel') }}
                </div>
              </caption>
              <tbody>
                <tr v-for="(i, item, index) in catPromoters.items" :key="index">
                  <td>{{ getCategoryName(item) }}</td>
                  <td style="width: 40%;">
                    <div class="mt-2">
                      <b-progress
                        :value="Math.round((i / catPromoters.qtd) * 100)"
                        :max="100"
                      ></b-progress>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      {{ Math.round((i / catPromoters.qtd) * 100) }}%
                    </div>
                  </td>
                  <td>
                    <div class="text-center">{{ i }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 mt-4" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <h1>
              <strong>
                {{ this.$t('reports.summaryBoard.top5passives') }}
              </strong>
            </h1>
            <table class="table" v-if="catPassives.qtd > 0">
              <caption>
                <div class="pull-right mr-3">
                  {{
                    percentilNps.passive
                      ? (
                          (100 * catPassives.qtd) /
                          percentilNps.passive
                        ).toFixed(0)
                      : 0
                  }}{{ this.$t('reports.summaryBoard.categorizedLabel') }}
                </div>
              </caption>
              <tbody>
                <tr v-for="(i, item, index) in catPassives.items" :key="index">
                  <td>{{ getCategoryName(item) }}</td>
                  <td style="width: 40%;">
                    <div class="mt-2">
                      <b-progress
                        variant="warning"
                        :value="Math.round((i / catPassives.qtd) * 100)"
                        :max="100"
                      ></b-progress>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      {{ Math.round((i / catPassives.qtd) * 100) }}%
                    </div>
                  </td>
                  <td>
                    <div class="text-center">{{ i }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <monthly-detractors-report />
          </div>
        </div>
        <div class="col-6" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <detractor-report />
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <rankings />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from 'vuex';
import dashboardBar from '@/components/molecules/dashboard-bar';
import npsBar from '@/components/molecules/nps-bar';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import detractorReport from '@/components/molecules/highcharts/detractor-report';
import monthlyDetractorsReport from '@/components/molecules/highcharts/monthly-detractors-report';
import rankings from '@/components/molecules/highcharts/reports/rankings';
import basicColumn from '@/components/molecules/highcharts/reports/basicColumn';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  name: 'SummaryBoard',
  components: {
    npsBar,
    dashboardBar,
    animatedNumber,
    loader,
    detractorReport,
    monthlyDetractorsReport,
    rankings,
    basicColumn,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    answersRequest: false,
    clientsRequest: false,
    invitesRequest: false,
    catPromoters: [],
    catDetractors: [],
    catPassives: [],
    details: {},
    branchRanking: 0,
    reportType: 'month',
    actionCategories: [],
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('dashboard', [
      'answersByPhone',
      'answersByEmail',
      'answersByManual',
      'answersByLinkWppWppWidgetQrCode',
      'amountAnswers',
      'amountClients',
      'amountInvites',
      'percentilNps',
    ]),
    ...mapState('charts', ['reportCategories']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getDashboardData();
    },

    myActionId: function watchmyActionId() {
      this.getDashboardData();
    },

    myActionsIds: function watchMyActionsIds() {
      this.getDashboardData();
    },

    calendarDates: function watchCalendarDates() {
      this.getDashboardData();
    },

    myIh1: function watchMyIh1() {
      this.getDashboardData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getDashboardData();
    },

    myIh2: function watchMyIh2() {
      this.getDashboardData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getDashboardData();
    },

    myMetric: function watchMyMetric() {
      this.getDashboardData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getDashboardData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getDashboardData();
    },
  },

  methods: {
    ...mapActions('dashboard', [
      'setAnswersByChannel',
      'setAmountAnswers',
      'setAmountClients',
      'setAmountInvites',
    ]),

    ...mapActions('charts', ['getReportCategories']),

    async getDashboardData() {
      this.loading = true;
      this.answersRequest = true;
      this.clientsRequest = true;
      this.invitesRequest = true;
      this.details = {
        total: 0,
        email: {
          valid: 0,
          percentil: 0,
        },
        sms: {
          valid: 0,
          percentil: 0,
        },
      };
      this.setAnswersByChannel({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      });
      this.setAmountAnswers({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.answersRequest = false;
      });
      this.setAmountInvites({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.invitesRequest = false;
      });
      await this.getReportCategories({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        metric: this.myMetric ? this.myMetric : null,
      }).then(() => {
        this.catPromoters.qtd = this.reportCategories.promoters.qtd;
        this.catPromoters.items = {};
        this.catDetractors.qtd = this.reportCategories.detractors.qtd;
        this.catDetractors.items = {};
        this.catPassives.qtd = this.reportCategories.passives.qtd;
        this.catPassives.items = {};
        let i = 0;
        for (const key in this.reportCategories.promoters.items) {
          if (i < 5) {
            this.catPromoters.items[key] = this.reportCategories.promoters.items[key];
          }
          i++;
        }
        i = 0;
        for (const key in this.reportCategories.detractors.items) {
          if (i < 5) {
            this.catDetractors.items[key] = this.reportCategories.detractors.items[key];
          }
          i++;
        }
        i = 0;
        for (const key in this.reportCategories.passives.items) {
          if (i < 5) {
            this.catPassives.items[key] = this.reportCategories.passives.items[key];
          }
          i++;
        }
      });

      const response = await api.get('/reports/details-by-channel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });
      if (response) {
        this.details = response.data;
      }
      if (this.myIh1 != 0) {
        const response = await api.get(`/nps-ranking/${this.userAuth.companyId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric ? this.myMetric : null,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
          },
        });
        if (response) {
          const rankingData = response.data;
          for (let i = 0; i < rankingData.length; i++) {
            if (this.myIh1 == rankingData[i].ih1) {
              this.branchRanking = parseInt(i) + 1;
              break;
            }
          }
        }
      }

      this.loading = false;
    },

    formatToPrice(value) {
      return value.toFixed(0);
    },
    async getCompanyCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: null,
          },
        });
        this.actionCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
      this.getCompanyCategories(),
      this.getDashboardData(),
    ]);
    this.loading = false;
  },

  beforeDestroy() {
    EventBus.$off('switch-chart');
    EventBus.$off('data-source');
    EventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss">
#number-nps {
  font-size: 50px !important;
}
</style>
<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.board-box {
  width: 10%;
  text-align: left;
  font-size: 16px;
  margin: 0px 20px;
  border: 1px solid #eee;
}
.board-box-value {
  float: right;
  padding-right: 40%;
  font-size: 24px;
}
.nps-display {
  border: none !important;
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
.board-border {
  border: 1px solid #eee;
}
.board-header h1 {
  font-size: 16px;
}
.summary {
  display: flex;
  flex-direction: row;
  margin-left: 5px;

  .board {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  .container {
    display: flex;
    flex-direction: row;
    padding: 0;
  }

  .item {
    display: flex;
    flex-direction: column;
    padding: 5px 8px;
    margin-right: 10px;
    min-height: 79px;
    max-height: 79px;
    min-width: 115px;
    max-width: 115px;
    -webkit-box-shadow: 0px 0px 9px -6px #000000;
    box-shadow: 0px 0px 9px -6px #000000;
    transition: 0.3s;

    &:hover {
      -webkit-box-shadow: 0px 0px 12px -6px #000000;
      box-shadow: 0px 0px 12px -6px #000000;
    }

    header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;


      h2 {
        font-size: 11px;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      align-items: center;

      span {
        font-size: 22px;
        font-weight: lighter;

        & + span {
          margin-top: -3px;
          font-size: 12px;
        }
      }
    }

    &:last-of-type {
      margin-right: 30px;
    }
  }
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/summary-board/index.vue